import axios from './request'
import config from '@/config'
import utils from '@/utils/utils'


const { baseURL } = config;
const inMobileApp = MG.utils.getQueryString('linkFrom') == '10086'  // 分省

const getHeaders = () => {
  const appType = inMobileApp ? 8 : 4  // 端内端外appType:4，分省appType:8
  const appChannel = MG.utils.getQueryString('channel') || MG.utils.getQueryString('appChannel') || ''
  const userId = localStorage.getItem('userId') ? +localStorage.getItem('userId') : ''
  const userToken = localStorage.getItem('userToken')
  return {
    userId,
    userToken,
    appType,
    appChannel,
  }
}

// 用户进入页面上报接口
export const enterReport = () => {   // 已替换
  let url = baseURL + 'h5/winterOlympic/v1.0.5.7/enterReport';
  const headers = getHeaders();
  return axios.post(url, {}, { headers });
}

// 分享成功上报
export const reportShare = () => { 
  let url = baseURL + 'h5/winterOlympic/v1.0.5.7/share';
  const headers = getHeaders();
  return axios.post(url, {}, { headers });
}

// 推荐游戏列表
export const queryRecommendGame = () => { // 已替换
  let url = baseURL + 'h5/winterOlympic/v1.0.5.7/queryRecGames';
  const headers = getHeaders();
  return axios.post(url, {}, { headers });
}

// 查询东奥勋章接口
export const queryMedal = () => { // 已替换
  let url = baseURL + 'h5/winterOlympic/v1.0.5.7/queryMedal';
  const headers = getHeaders();
  return axios.post(url, {}, { headers });
}

// 任务查询接口
export const queryTaskInfo = () => {
  let url = baseURL + 'h5/winterOlympic/v1.0.5.7/queryTaskInfo';
  const headers = getHeaders();
  return axios.post(url, {}, { headers });
}

// 奖励领取接口
export const rewardCollection = (param) => {
  let url = baseURL + 'h5/winterOlympic/v1.0.5.7/receivePrize';
  const headers = getHeaders();
  return axios.post(url, param, { headers });
}

//我的奖品列表
export const queryPrizeList = function(param) {
    let url = baseURL + 'h5/lottery/v1.0.4.9/listPrizeRecord'
    return axios.post(url, param.data, { headers: param.headers })
}







// WEBPACK FOOTER //
// ./src/api/winterOlympicApi.js